import React, { useMemo } from 'react'
import NewUserDashboard from './NewUserDashboard.jsx'
import PartyUserDashboard from './PartyUserDashboard.jsx'
import MembersUserDashboard from './MembersUserDashboard.jsx'

export default function App() {
  // Extract subdomain from hostname
  const subdomain = useMemo(() => {
    const hostname = window.location.hostname
    const parts = hostname.split('.')

    // For localhost development (e.g., join.localhost, admin.localhost)
    if (hostname.includes('localhost')) {
      return parts[0] === 'localhost' ? null : parts[0]
    }

    // For production domains (e.g., join.example.com, admin.example.com)
    if (parts.length > 2) {
      return parts[0]
    }

    return null
  }, [])

  // Route based on subdomain
  if (subdomain === 'join') {
    return <NewUserDashboard />
  }

  if (subdomain === 'admin') {
    return <PartyUserDashboard />
  }
  if (subdomain === 'member') {
    return <MembersUserDashboard />
  }

  // Default to PartyUserDashboard for no subdomain or unrecognized subdomains
  return <PartyUserDashboard />
}
